/**
 * Layout-only defaults for the executive summary demo route (no project-specific copy).
 * Live data comes from APIs when opened from Project Insights.
 */
import type { HealthChip, HeroData, Milestone, Phase, ReferenceLink, RaidItem } from './executiveSummaryTypes';

function todayUk(): string {
  return new Date().toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
}

export const defaultHeroShell: HeroData = {
  title: 'Executive summary',
  pr: '—',
  client: '—',
  tagline: '',
  lastUpdated: todayUk(),
  rag: { level: 'green', label: '—' },
  kpis: [],
};

export const defaultPhaseRing: Phase[] = [{ label: 'MILESTONES', kind: 'outline' }];

export const emptyMilestones: Milestone[] = [];

export const emptyHealthChips: HealthChip[] = [];

export const emptyReferenceLinks: ReferenceLink[] = [];

export const emptyRaidItems: RaidItem[] = [];

export const defaultPhaseFill = 0;
